import { generatedApi } from '@shared/api';
import { authActions } from '@shared/redux/ducks/auth';

export const teamsEndpoints = {
  membersListTeamListGet: {
    providesTags: ['team'],
  },
  createInviteLinkTeamCreateInviteLinkGet: {
    providesTags: ['team'],
  },

  createInviteLinkTeamJoinPost: {
    invalidatesTags: [],
    async onQueryStarted(_, { dispatch, queryFulfilled }) {
      const { data } = await queryFulfilled;
      dispatch(authActions.updateUserOrganization(data));
      dispatch(authActions.setCurrentOrganizationInfo(data));
    },
  },

  removeMemberTeamRemoveDelete: {
    invalidatesTags: [],
    async onQueryStarted(queryArgs, { dispatch, queryFulfilled, getState }) {
      await queryFulfilled;

      const cachedMemberList = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'membersListTeamListGet',
      );

      cachedMemberList.forEach((args) => {
        if (args.organizationId !== queryArgs.bodyRemoveMemberTeamRemoveDelete.organization_id)
          return;

        dispatch(
          generatedApi.util.updateQueryData('membersListTeamListGet', args, (draft) => {
            const memberIndex = draft.findIndex(
              (member) =>
                member.user_info.id === queryArgs.bodyRemoveMemberTeamRemoveDelete.user_id,
            );

            if (memberIndex !== -1) {
              draft.splice(memberIndex, 1);
            }
          }),
        );
      });
    },
  },

  updatePermissionTeamUpdatePermissionPost: {
    invalidatesTags: [],
    async onQueryStarted(queryArgs, { dispatch, queryFulfilled, getState }) {
      const { data } = await queryFulfilled;

      const cachedMemberList = generatedApi.util.selectCachedArgsForQuery(
        getState(),
        'membersListTeamListGet',
      );

      cachedMemberList.forEach((args) => {
        dispatch(
          generatedApi.util.updateQueryData('membersListTeamListGet', args, (draft) => {
            const memberIndex = draft.findIndex(
              (member) =>
                member.user_info.id ===
                queryArgs.bodyUpdatePermissionTeamUpdatePermissionPost.user_id,
            );

            if (memberIndex !== -1) {
              draft[memberIndex].permission = data.permission;
            }
          }),
        );
      });
    },
  },
} satisfies Parameters<typeof generatedApi.enhanceEndpoints>[0]['endpoints'];
